"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _Element = _interopRequireDefault(require("../01_atoms/Element"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

var _SelectedPassengers = _interopRequireDefault(require("./SelectedPassengers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PassengerDetails = function PassengerDetails() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      title = _ref.title,
      subtitle = _ref.subtitle,
      elementStyle = _ref.elementStyle,
      onEdit = _ref.onEdit,
      onEditLink = _ref.onEditLink,
      _ref$highlightEditBut = _ref.highlightEditButton,
      highlightEditButton = _ref$highlightEditBut === void 0 ? false : _ref$highlightEditBut,
      _ref$passengers = _ref.passengers,
      passengers = _ref$passengers === void 0 ? [] : _ref$passengers,
      _ref$translator = _ref.translator,
      t = _ref$translator === void 0 ? function (txt) {
    return txt;
  } : _ref$translator,
      otherProps = _objectWithoutProperties(_ref, ["title", "subtitle", "elementStyle", "onEdit", "onEditLink", "highlightEditButton", "passengers", "translator"]);

  return /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: title,
    subtitle: subtitle
  }, /*#__PURE__*/_react["default"].createElement(_Element["default"], {
    style: elementStyle
  }, /*#__PURE__*/_react["default"].createElement(_SelectedPassengers["default"], _extends({
    passengers: passengers
  }, otherProps)), (onEditLink || onEdit) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "edit-passengers-button",
    to: onEditLink,
    onClick: onEdit,
    fluid: true,
    primary: highlightEditButton,
    style: {
      marginTop: 20
    }
  }, passengers.length === 0 ? t('Select passengers') : t('Change passengers'))));
};

var _default = PassengerDetails;
exports["default"] = _default;